import React, { useContext, useEffect, useState } from "react";
import { Player } from "../../interfaces/Player.Interface";
import Inputbox from "./Inputbox.Element";
import "./MoneyComponent.Styles.scss";
import image from "../../img/player_default.png";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { dateToFirestore } from "../../services/DateToFirestore";

interface Props {
  player: Player;
  date: Date;
}

export default function MoneyComponentElement(props: Props) {
  const [donation, setDonation] = useState(0);
  const firebase = useContext(firebaseContext);
  const { player, date } = props;
  let timeOut: any;

  useEffect(() => {
    const getData = async () => {
      const donationQ = await firebase
        .firestore()
        .collection("donations")
        .where("date", "==", dateToFirestore(date))
        .where("playerId", "==", player.playerId)
        .get();

      if (!donationQ.empty) {
        setDonation(donationQ.docs[0].data().donation);
      } else {
        setDonation(0);
      }
    };

    getData();
  }, [firebase, date]);

  const onChange = async (val: string) => {
    const db = firebase.firestore().collection("donations");

    setDonation(parseInt(val));
    clearTimeout(timeOut);

    timeOut = setTimeout(async () => {
      const donationQ = await db
        .where("date", "==", dateToFirestore(date))
        .where("playerId", "==", player.playerId)
        .get();

      if (donationQ.empty) {
        db.add({
          playerId: player.playerId,
          date: dateToFirestore(date),
          donation: parseInt(val),
        });
      } else {
        donationQ.docs[0].ref.update({
          donation: parseInt(val) || 0,
        });
      }
    }, 1000);
  };

  return (
    <div className="player-money-component">
      <div>
        <img
          height={70}
          style={{ paddingRight: 20 }}
          src={player.imageUrl || image}
          alt=""
        />
      </div>
      <div className="player-name-component">
        {props.player.firstName} {props.player.lastName}
      </div>
      <div className="player-donation-input">
        <Inputbox
          id={"player-money-" + player.playerId}
          value={donation.toString()}
          onChange={onChange}
          label="Donation"
          placeHolder="0"
          helperText="Enter in rupees ex: 100"
          type="number"
        />
      </div>
      {/* <div className="player-donation-status">
        {<Button text="Save" intent="success" />}
        <Button text="Delete" intent="danger" />
      </div> */}
    </div>
  );
}
